// import React, { useState } from 'react';

// const FloatingLabelInput = ({ label, type = "text", id, name, value, onChange }) => {
//   const [focused, setFocused] = useState(false);

//   return (
//     <div className="relative w-full  focus:border-blue-600">
//       <input
//         id={id}
//         name={name}
//         type={type}
//         value={value}
//         onChange={onChange}
//         onFocus={() => setFocused(true)}
//         onBlur={(e) => setFocused(e.target.value !== '')}
//         className="block text-black  w-full px-5 border-2  border-gray-300 py-5 bg-transparent rounded-sm  appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
//         placeholder=" "
//       />
//       <label
//         htmlFor={id}
//         className={`absolute left-5 top-[20px] text-gray-500 transition-all duration-200 transform ${
//           focused || value ? "text-[10px] -translate-y-3.5" : "text-[10px] translate-y-0"
//         } peer-placeholder-shown:text-[16px] peer-placeholder-shown:translate-y-0 peer-focus:text-[10px] peer-focus:-translate-y-3.5`}
//       >
//         {label}
//       </label>
//     </div>
//   );
// };

// export default FloatingLabelInput;
import React, { useEffect, useState } from "react";
import { FaInfoCircle } from "react-icons/fa";

const FloatingLabelInput = ({
  label,
  type = "text",
  id,
  name,
  value,
  onChange,
  onBlur,
  error,
  defaultValue,
  onKeyDown,
  required = false,
  placeholder
}) => {
  const [focused, setFocused] = useState(false);
  const [inputValue, setInputValue] = useState(defaultValue || "");
  useEffect(() => {
    if (defaultValue !== undefined) {
      setInputValue(defaultValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    if (value !== undefined) {
      setInputValue(value);
    }
  }, [value]);

  const handleChange = (e) => {
    setInputValue(e.target.value);
    if (onChange) {
      onChange(e);
    }
  };
  return (
    <div>
      <div className="relative w-full border-2 h-[60px]">
        <input
          id={id}
          name={name}
          type={type}
          value={inputValue}
          onChange={onChange}
          onKeyDown={onKeyDown}
          // defaultValue={defaultValue}
          onBlur={(e) => {
            setFocused(e.target.value !== "");
            if (onBlur) onBlur(e); // Call parent onBlur if provided
          }}
          onFocus={() => setFocused(true)}
          className={`block text-black  w-full px-[20px] h-full appearance-none focus:outline-none focus:ring-0 peer ${
            error
              ? "border-red-500 focus:border-red-500"
              : "border-gray-300 focus:border-blue-600"
          }`}
          placeholder= {placeholder ? placeholder : ""}
          required={required}
        />
        <label
          htmlFor={id}
          className={`absolute left-5 top-[16px]  text-gray-500 transition-all duration-200 transform ${
            focused || value || defaultValue
              ? "text-[10px] -translate-y-3.5"
              : "text-[10px] translate-y-0"
          } peer-placeholder-shown:text-[16px] peer-placeholder-shown:translate-y-0 peer-focus:text-[10px] peer-focus:-translate-y-3.5`}
        >
          {label}
        </label>
      </div>
      {error && (
        <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
          <FaInfoCircle/>
          <p className="text-white py-1 px-2  text-sm my-2">{error}</p>
        </div>
      )}
    </div>
  );
};

export default FloatingLabelInput;
